<template>
  <v-app>
    <div v-if="showCustomHeaders" >
      <home-header v-show="customHeaderType === 'home'" @showEvents="displayEvents"></home-header>
      <form-header v-show="customHeaderType === 'form'"></form-header>
    </div>
    <div v-else>
      <v-toolbar app>
        <v-toolbar-title class="headline text-uppercase">
          <span class="font-weight-xbold">Learn To Play</span>
          <span class="font-weight-light"> Remote Registration</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </div>
    <div id="events"></div>
    <v-expand-transition>
      <v-content v-show="showEventList">
        <v-slide-x-transition mode="out-in">
          <router-view/>
        </v-slide-x-transition>
      </v-content>
    </v-expand-transition>
    <v-footer app absolute>
      <default-footer></default-footer>
    </v-footer>
  </v-app>
</template>

<script>
import formHeader from './components/layout/FormHeader'
import homeHeader from './components/layout/HomeHeader'
import defaultFooter from './components/layout/DefaultFooter'
// import defaultFooter from './components/layout/DefaultFooter'

export default {
  name: 'App',
  components: {
    formHeader,
    homeHeader,
    defaultFooter
  },
  data () {
    return {
      showCustomHeaders: true,
      customHeaderType: 'home',
      showEventList: true
    }
  },
  methods: {
    displayEvents() {
      setTimeout(()=>{
        this.$vuetify.goTo('#events')
      }, 50)
      // this.showEventList = true
    }
  },
  mounted () {
    this.$store.dispatch('loadInitialState')
  },
  watch: {
    '$route'(val) {
      switch (val.name) {
        case 'registrationForm':
          this.customHeaderType = 'form'
        break;
        case 'eventDetail':
        case 'eventList':
        default:
          this.customHeaderType = 'home'
      }
    }
  }
}
</script>

<style>
* {
  border-color: rgba(0,0,0,0);
}
.v-content {
  margin-bottom: 4rem;
}
</style>
